<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M80 96C88.8 96 96 103.2 96 112L96 464C96 490.5 117.5 512 144 512L560 512C568.8 512 576 519.2 576 528C576 536.8 568.8 544 560 544L144 544C99.8 544 64 508.2 64 464L64 112C64 103.2 71.2 96 80 96zM208 320C216.8 320 224 327.2 224 336L224 432C224 440.8 216.8 448 208 448C199.2 448 192 440.8 192 432L192 336C192 327.2 199.2 320 208 320zM320 208L320 432C320 440.8 312.8 448 304 448C295.2 448 288 440.8 288 432L288 208C288 199.2 295.2 192 304 192C312.8 192 320 199.2 320 208zM400 256C408.8 256 416 263.2 416 272L416 432C416 440.8 408.8 448 400 448C391.2 448 384 440.8 384 432L384 272C384 263.2 391.2 256 400 256zM512 144L512 432C512 440.8 504.8 448 496 448C487.2 448 480 440.8 480 432L480 144C480 135.2 487.2 128 496 128C504.8 128 512 135.2 512 144z"
      fill="currentColor"
    />
  </svg>
</template>
